import React, { Component } from 'react';
import {
	Routes,
	Route,
	NavLink,
	Navigate,
	useNavigate,
	useLocation,
  } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Inventory from './Menu/Stock/StockDashboard';
import Moment from 'moment';

import BoxList from './Menu/paygResumeInfoList.jsx';
// import MapPAYGO from './Menu/paygUserMap_OpenStreetMap';
import Dashboard from './Menu/mainDashboard.jsx';
import UserRepayment from './Menu/paygUserRepayment.jsx';
import EnterPayment from './Menu/paygPaymentNew.jsx';
import Commercial from './Menu/commercial.jsx';
import ReportList from './Menu/maintenanceList.jsx';
import RecoveryList from './Menu/recoveryList.jsx';
import Configuration from './AdminDashboard/AdminDashboard';
import Devis from './Menu/Devis/Devis.jsx'
import Financement from './Menu/CrowdLending/ProjectList.jsx'
import Spendings from './Menu/Spendings/Spendings';
import Production from '../superAdmin/Menu/energy_data_views.jsx';
import Consommation from '../superAdmin/Menu/consommation.jsx';

import Page from '../commonModules/layouts/Page';
import { showNotif, cleanNotif } from "../../../../jsx/actions/notifAction"

import ClassesProps from "./HOC/ClassesProps"
import { Alert } from '@material-ui/lab';
import Home from './Menu/Home';
import ExtractList from './AdminDashboard/ExtractList';
import ExtractSingle from './AdminDashboard/ExtractSingle';
import TransferGraph from './Menu/TransferGraph/TransferGraph.jsx';
import RFIDGraphComponent from './Menu/RFIDGraph/RFIDGraph.jsx';
// import TransferReplay from './Menu/TransferReplay/TransferReplay';

const URL_APP_MG_V2 = process.env.REACT_APP_URL_MINIGRID_UI;

function MainContent(props){
		// Get accountIdFromAuth (the current account ID)
		const accountIdFromAuth = props.auth?.user?.accountid || localStorage.accountId || '';
		
		// Find the userId corresponding to accountIdFromAuth in accountAccessList
		// Each account has its own specific userId in the accountAccessList
		let userId = '';
		if (accountIdFromAuth && props.auth?.user?.accountAccessList) {
			const accountAccess = props.auth.user.accountAccessList.find(
				acc => acc.accountid === accountIdFromAuth
			);
			if (accountAccess) {
				userId = accountAccess.userid;
			}
		}
		
		// Fallback to user.id if not found in accountAccessList
		if (!userId) {
			userId = props.auth?.user?.id || localStorage.userId || '';
		}
		
		const accountId = accountIdFromAuth || userId;

		return (
			<div>
				      <Routes>
					  
						<Route  path="dashboard" element={<Dashboard ClickOnMenu={props.ClickOnMenu} {...props} />} />
						<Route  path="home" element={<Home ClickOnMenu={props.ClickOnMenu} {...props} />} />
					  	<Route  path="quote" element={<Page><Devis {...props} /></Page>} />
					  	<Route  path="spendings" element={<Page><Spendings {...props} /> </Page>} />
					  	<Route  path="recovery" element={<Page><RecoveryList {...props} /> </Page>} />
					  	<Route  path="commercial" element={<Page><Commercial {...props} /> </Page>} />
					  	<Route  path="maintenance" element={<Page><ReportList {...props.mainContentProps} CLASSES={props.CLASSES} /> </Page>} />
					  	<Route  path="configuration" element={<Configuration {...props.mainContentProps} {...props} />} />
					  	<Route  path="extracts" element={<Page><ExtractSingle {...props} /> </Page>} />
					  	<Route  path="store" element={<Inventory {...props} />} />
					  	<Route path="transfer-graph/:transferId" element={<Page><TransferGraph {...props} /></Page>} />
					  	<Route path="rfid-graph" element={<Page><RFIDGraphComponent {...props} /></Page>} />
					  	<Route path="rfid-graph/:rfid" element={<Page><RFIDGraphComponent {...props} /></Page>} />
						{/* <Route path="transfer-replay/:transfer_id?" element={<TransferReplay />} /> */}
					  	<Route  path="userlist" element={<Page><BoxList tokenUser= {props.tokenUser} {...props} /></Page>} />
					  	<Route  path="production" element={<Production
							agg="pt1hour"
							timeFrom= {Moment().add(-10, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							timeTo = {Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							ChartName = {'Consommation Journalière'}
							sensor= {'panel,load current,panel power,system yield,battery voltage'}
							graphName = {'Consommation par jour des 10 derniers jours'}
							{...props} 
						/>} />
					  	<Route  path="consumption" element={<Consommation
							tokenUser= {props.tokenUser}
							agg="pt1hour"
							timeFrom= {Moment().add(-6, 'months').utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							timeTo = {Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ')}
							ChartName = {'Consommation Journalière'}
							sensor= {""}
							graphName = {'Consommation par jour des 6 derniers mois'}
							{...props} 
						/>} />
					  	<Route  path="paymentlist" element={<Page><UserRepayment tokenUser= {props.tokenUser} {...props.mainContentProps} {...props} /> </Page>} />
					  	<Route  path="payment" element={<Page><EnterPayment {...props} /> </Page>} />
					  	<Route  path="minigrid" element={<iframe
								src={
									URL_APP_MG_V2 +
									"/main/?t=" +
									localStorage.tokenMG +
									"&userId="+userId+
									"&accountId="+accountId
									/*+"&nosidebar=true"*/
								}
								className="iframe"
								title="spen-demand"
								sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-top-navigation-by-user-activation' 
								style={{width:"100vw",height:"100vh",border:0,marginTop:"64px"}}
								></iframe>} />
				      </Routes>
			</div>
		);
};

function mapStateToProps(state){
  return {
		downloading: state.extract.fetching,
		SHOW_NOTIF: state.notif.show,
		MESSAGE: state.notif.message,
		TYPE: state.notif.type,
		auth: state.auth,
  }
}

function mapDispatchToProps(dispatch){  
	return bindActionCreators({
		showNotif,
		cleanNotif,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
//export default ClassesProps(connect(mapStateToProps, mapDispatchToProps)(MainContent));
